import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/sharp-solid-svg-icons';
import React from 'react';

import AcresLogo from '@/components/icons/AcresLogo';

type Props = {
  children?: React.ReactNode;
};

const LoadingScreen = ({ children = undefined }: Props) => {
  return (
    <>
      <div className="absolute bottom-0 left-0 right-0 top-0 z-[1000] flex h-screen w-screen flex-col items-center justify-center bg-white">
        <AcresLogo className="mb-[36px] w-[100px]" />
        <FontAwesomeIcon
          spinPulse
          data-testid="loading-spinner"
          icon={faSpinner}
          size="xl"
        />
      </div>
      {children}
    </>
  );
};

export default LoadingScreen;
